import React, {Component, Fragment} from "react";
import DataTableForm from "../Components/Forms";
import {_getFields, _post, _put} from "../Api";
import {
    Form,
    Button,
    UncontrolledAlert
} from "reactstrap";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faWindowClose,
    faCloudUploadAlt
} from '@fortawesome/free-solid-svg-icons'

class Add extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formAdd: {},
            errorMessage: {},
            successMessage: this.props.formAddNotification
        };

        this.handleUploadImages = this.handleUploadImages.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    queryAPI() {
        _getFields(this.props.db).then(res => {
            this.setState({api: res.data}, () => {
            })
        })
    }

    componentDidMount() {
        this.queryAPI();
        if (this.state.successMessage) {
            setTimeout(() => {
                this.setState({
                    successMessage: false
                })
            }, 3000)
        }
    }

    handleUploadPut() {
        (this.state.selectedFiles) && this.state.selectedFiles.map(async (file) => {
            let formData = new FormData();
            formData.append('files', file)
            await _post(this.props.db + "/" + res.data.inserted_id + "/" + file.fieldName, formData)
        })
        this.props.notificationComponent({type: "success", message: ["Data saved successfully"]})
        this.props.hideComponent({component: 'refreshList'})
    }

    handleSubmit(e) {
        e.preventDefault();

        _put(this.props.db, this.state.formAdd).then(res => {
            (res.result === 'success')
                ? this.handleUploadPut()
                : this.props.notificationComponent({type: "error", message: res.data.messages})
        })
    }

    handleChange(e) {
        const formAdd = this.state.formAdd;
        formAdd[e.target.name] = e.target.value
        this.setState({
            formAdd: formAdd
        })
    }

    handleUploadImages(files) {
        this.setState({selectedFiles: files})
    }

    render() {

        return (
            <Fragment>
                {(this.state.api) &&
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="card-body">
                                    <h4 className="card-title">Add</h4>
                                    <p className="card-title-desc">&nbsp;</p>
                                    <Form onSubmit={this.handleSubmit}>
                                        {this.state.api.fields ? this.state.api.fields.map((field, i) => {
                                            return (
                                                <DataTableForm key={i}
                                                               fields={field}
                                                               formAdd={this.state.formAdd[field.name]}
                                                               onChange={this.handleChange}
                                                               upload={this.handleUploadImages}/>
                                            )
                                        }) : null}
                                        <div className="row mb-3">
                                            <div className="col-sm-2 col-4 col-form-label">&nbsp;</div>
                                            <div className="col-sm-10 col-8">
                                                <Button outline
                                                        color="primary"
                                                        className="me-2">
                                                    <FontAwesomeIcon icon={faCloudUploadAlt}/> Submit
                                                </Button>

                                                <Button
                                                    onClick={() => this.props.hideComponent({component: 'showList'})}
                                                    outline
                                                    color={"secondary"}>
                                                    <FontAwesomeIcon icon={faWindowClose}/> Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </Fragment>
        )
    }
}

export default Add;